<template>
  <div class="d-flex in-component">
    <v-col
      cols="12"
      class="py-0">
      <v-row>
        <v-col>
          <ValidationProvider
            v-slot="{ errors }"
            :name="label"
            :rules="disableGroup ? rules : null">
            <v-select
              :items="items"
              :value="value"
              item-text="label"
              item-value="value"
              class="dropdown-field"
              :error-messages="errors[0]"
              :disabled="!disableGroup"
              solo
              dense
              @change="(val) => $emit('input', val)" />
          </ValidationProvider>
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import SchemaController from '@/utils/schemaController'

export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => []
    },
    rules: {
      type: String,
      default: ''
    },
    disableGroup: {
      type: Boolean,
      required: true
    },
    optionFunc: {
      type: String,
      default: 'none'
    }
  },
  data () {
    return {
      items: []
    }
  },
  async mounted () {
    this.items = this.optionFunc === 'none' ? this.options : await SchemaController[this.optionFunc]()
  }
}
</script>

<style scoped>
.dropdown-field {
  width: 362px;
  margin-top: -10px;
}

.dropdown-field .v-input__control {
  height: 50px;
}
</style>
